// src/components/Gallery.jsx
import { useState, useEffect } from "react";

const images = [
  { src: "https://github.com/ganeshvgs/bcm-images/blob/main/photo1.jpg?raw=true", caption: "Front View of Hostel" },
  { src: "https://github.com/ganeshvgs/bcm-images/blob/main/photo2.jpg?raw=true", caption: "Group Photo of Students" },
  { src: "https://github.com/ganeshvgs/bcm-images/blob/main/photo3.jpg?raw=true", caption: "Festival Celebration" },
  { src: "https://github.com/ganeshvgs/bcm-images/blob/main/photo4.jpg?raw=true", caption: "Sports Achievements" },
  { src: "https://github.com/ganeshvgs/bcm-images/blob/main/photo5.jpg?raw=true", caption: "Main Entrance Area" },
  { src: "https://github.com/ganeshvgs/bcm-images/blob/main/photo6.png?raw=true", caption: "Meal / Dining" },
];

export default function Gallery() {
  const [selected, setSelected] = useState(null);

  // ✅ Close modal on Esc key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setSelected(null);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <section id="gallery" className="bg-cream py-20 px-6 md:px-10">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-maroon mb-12">
          Gallery
        </h2>

        {/* Responsive Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {images.map((item, index) => (
            <div
              key={index}
              className="relative group rounded-xl overflow-hidden shadow-lg cursor-pointer transform transition duration-500 hover:-translate-y-2 hover:shadow-2xl"
              onClick={() => setSelected(item)}
            >
              {/* Image */}
              <img
                src={item.src}
                alt={item.caption}
                className="w-full h-[220px] sm:h-[260px] md:h-72 object-cover transition-transform duration-500 group-hover:scale-110"
              />

              {/* Overlay Caption */}
              <div className="absolute bottom-0 left-0 w-full bg-black/70 text-white text-sm sm:text-base px-4 py-2 opacity-0 group-hover:opacity-100 translate-y-full group-hover:translate-y-0 transition-all duration-500">
                {item.caption}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal Lightbox */}
      {selected && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 animate-fade-in"
          onClick={() => setSelected(null)}
        >
          <div
            className="relative bg-white rounded-xl overflow-hidden shadow-2xl max-w-4xl w-full p-4 animate-scale-up"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selected.src}
              alt={selected.caption}
              className="w-full h-[400px] md:h-[500px] object-contain rounded"
            />
            <p className="text-center mt-4 text-lg font-semibold text-gray-800">
              {selected.caption}
            </p>
            <button
              onClick={() => setSelected(null)}
              className="absolute top-3 right-3 bg-maroon text-white px-3 py-1 rounded-full shadow hover:bg-red-600 transition"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
